const PROXY_PATHS = {
    gtm: '/gtm',
    ga: '/ga',
    phAssets: '/ph-q/static',
    ph: '/ph-q',
    invoca: '/ivr',
} as const;

export default PROXY_PATHS;
